import { Suspense, type ReactNode } from "react";
import { AuthGuard } from "../components/feature/AuthGuard";

function RouteFallback() {
  return (
    <div
      role="status"
      aria-label="Loading page"
      className="min-h-screen bg-slate-50 flex items-center justify-center"
    >
      <div className="h-6 w-6 rounded-full border-2 border-slate-200 border-t-coral-600 animate-spin" />
    </div>
  );
}

export function LazyRoute({ children }: { children: ReactNode }) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}

export function ProtectedRoute({ children }: { children: ReactNode }) {
  return (
    <AuthGuard>
      <LazyRoute>{children}</LazyRoute>
    </AuthGuard>
  );
}

